var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M40.5731094,3.55271368e-15 L48.1174699,9.60948032 L40.4978606,17.3204032 L39.0752488,15.9146381 L44.913,10.006 L0.0126574673,10.2910875 L0,8.29112758 L44.319,8.011 L39,1.23504123 L40.5731094,3.55271368e-15 Z","fillRule":"nonzero"}));
}

ArrowRight.defaultProps = {"viewBox":"0 0 49 18","version":"1.1"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
